import { render, staticRenderFns } from "./ReceiverOrderInfoTrackingHistory.vue?vue&type=template&id=7726226d&"
import script from "./ReceiverOrderInfoTrackingHistory.vue?vue&type=script&lang=js&"
export * from "./ReceiverOrderInfoTrackingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports